
routes.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider'];

export default function routes($stateProvider, $urlRouterProvider, $locationProvider) {
      $locationProvider.html5Mode(true);
      //$urlRouterProvider.otherwise('/');

  $stateProvider
     .state('app.integracion', {
            abstract: false,
            url: '/panel-integracion/integracion',
            template: require('./integration_action/execute/executeDataView.html'),
            controller: 'executeDataController',
            controllerAs:'executeData'
      });
     
 
}



// WEBPACK FOOTER //
// ./src/app/integration-front/integrationPanel.route.js